import { neutralColors } from './colors/colors.js';

var getModeStyles = function getModeStyles(mode) {
  if (mode === "light") {
    return {
      background: neutralColors.white,
      borderColor: neutralColors.silver,
      color: neutralColors.charcoal
    };
  } else {
    return {
      background: neutralColors.charcoal,
      borderColor: neutralColors.charcoal,
      color: neutralColors.white
    };
  }
};

export { getModeStyles };
